import view from '../../view';
import constants from '../constants';
import getParentGlobalElement from '../helpers/get-parent-global-element';
import getDetachedChildrenArray from '../helpers/get-detached-children-array';
import getGlobalBySource from '../selectors/global-by-source';
import isElementDetached from '../verifiers/is-element-detached';

const { actionTypes, attributes } = constants;

const resetGlobal = (store) => (next) => (action) => {
  switch (action.type) {
    case actionTypes.RESET_GLOBAL: {
      const state = store.getState();
      const { globalElement: liveGlobalElement } = action.payload;

      const globalElementId = view.accessors.getLiveElementId(liveGlobalElement);
      const globalElement = view.accessors.getStaticElement(globalElementId);

      globalElement.removeAttribute(attributes.DETACHED_GLOBAL);

      let elementToReplace = globalElement;
      let parentGlobalElement = getParentGlobalElement(globalElement);

      while (parentGlobalElement) {
        if (!isElementDetached(elementToReplace)) {
          const previouslyDetachedChildrenArray = getDetachedChildrenArray(parentGlobalElement);

          const childSource = elementToReplace.getAttribute('src');
          const { id: detachedChildName } = getGlobalBySource(state, childSource);

          const detachedChildrenArray = previouslyDetachedChildrenArray.filter(
            (childName) => childName !== detachedChildName
          );

          if (detachedChildrenArray.length) {
            parentGlobalElement.setAttribute(
              attributes.DETACHED_CHILDREN_GLOBAL,
              detachedChildrenArray.join(' ')
            );
          } else {
            parentGlobalElement.removeAttribute(attributes.DETACHED_CHILDREN_GLOBAL);
          }
        }

        elementToReplace = parentGlobalElement;
        parentGlobalElement = getParentGlobalElement(parentGlobalElement);
      }

      const liveElementToReplace = view.accessors.getLiveElementByStaticElement(elementToReplace);
      const elementToReplaceId = view.accessors.getLiveElementId(liveElementToReplace);

      view.operations.replaceElement(elementToReplace, elementToReplaceId);

      next(action);
      break;
    }

    default:
      next(action);
  }
};

export default resetGlobal;
